"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBackgroundCallback = void 0;
const react_1 = require("react");
const useBeforeUnload_1 = __importDefault(require("./useBeforeUnload"));
const useInterval_1 = __importDefault(require("./useInterval"));
const useLatest_1 = __importDefault(require("./useLatest"));
/**
 * Calls a function fairly reliably
 */
function useBackgroundCallback(callback, { debug = false, interval = 30 * 1000 } = {}) {
    const latestCallback = (0, useLatest_1.default)(callback);
    const callbackWithMessage = (reason) => {
        return () => {
            if (debug) {
                console.log(`BACKGROUND SAVE - ${reason}`);
            }
            latestCallback.current();
        };
    };
    // Save at regular intervals.
    (0, useInterval_1.default)(callbackWithMessage("Interval"), interval);
    // Save when this component unloads.
    (0, react_1.useEffect)(() => callbackWithMessage("Component Unmounting"), []);
    // Save before the page is closed.
    (0, useBeforeUnload_1.default)(callbackWithMessage("Window Unloading"));
}
exports.useBackgroundCallback = useBackgroundCallback;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQmFja2dyb3VuZENhbGxiYWNrLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ob29rcy91c2VCYWNrZ3JvdW5kQ2FsbGJhY2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaUNBQWtDO0FBQ2xDLHdFQUFnRDtBQUNoRCxnRUFBd0M7QUFDeEMsNERBQW9DO0FBT3BDOztHQUVHO0FBQ0gsU0FBZ0IscUJBQXFCLENBQ25DLFFBQW1CLEVBQ25CLEVBQUUsS0FBSyxHQUFHLEtBQUssRUFBRSxRQUFRLEdBQUcsRUFBRSxHQUFHLElBQUksS0FBbUMsRUFBRTtJQUUxRSxNQUFNLGNBQWMsR0FBRyxJQUFBLG1CQUFTLEVBQUMsUUFBUSxDQUFDLENBQUM7SUFDM0MsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLE1BQWMsRUFBRSxFQUFFO1FBQzdDLE9BQU8sR0FBRyxFQUFFO1lBQ1YsSUFBSSxLQUFLLEVBQUU7Z0JBQ1QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxxQkFBcUIsTUFBTSxFQUFFLENBQUMsQ0FBQzthQUM1QztZQUNELGNBQWMsQ0FBQyxPQUFPLEVBQUUsQ0FBQztRQUMzQixDQUFDLENBQUM7SUFDSixDQUFDLENBQUM7SUFFRiw2QkFBNkI7SUFDN0IsSUFBQSxxQkFBVyxFQUFDLG1CQUFtQixDQUFDLFVBQVUsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQ3ZELG9DQUFvQztJQUNwQyxJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFLENBQUMsbUJBQW1CLENBQUMsc0JBQXNCLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNqRSxrQ0FBa0M7SUFDbEMsSUFBQSx5QkFBZSxFQUFDLG1CQUFtQixDQUFDLGtCQUFrQixDQUFDLENBQUMsQ0FBQztBQUMzRCxDQUFDO0FBcEJELHNEQW9CQyJ9